module.exports = "#download-icon i {\n  font-size: 26px;\n  padding-top: 2px;\n  color: #0082CA; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/project-summary-readiness/project-summary-readiness.component.scss
// module id = ./src/app/components/project-summary-readiness/project-summary-readiness.component.scss
// module chunks = main